import { h } from 'preact'

export const SelectIcon = () => (
  <svg className="icon" width="24px" height="24px" viewBox="0 0 24 24">
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <polyline points="6 9 12 3 18 9" />
      <polyline points="6 15 12 21 18 15" />
    </g>
  </svg>
)
